import React from 'react'
import { DynamicPowerPricesEnabledContextProps } from '../types'

export const DynamicPowerPricesEnabledContext = React.createContext<DynamicPowerPricesEnabledContextProps>({
  isDynamicPowerPriceEnabledForWallboxes: false,
  isDynamicPowerPriceEnabledForBattery: false,
  isDynamicPowerPriceEnabled: false,
  isDynamicPowerPriceLoading: false,
})
